import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";

const BillingEmail = () => {
  const { t } = useTranslation();
  return (
    <Form.Item
      name="billing_email"
      label={t("billing.billingEmailLabel")}
      normalize={(value) => (value ? value.replace(/[^\x20-\x7E]/g, "").trim() : value)}
      rules={[
        {
          required: true,

          message: t("billing.billingEmailRequired"),
        },
        {
          type: "email",
          message: t("billing.billingEmailInvalid"),
        },
      ]}
      hasFeedback
    >
      <Input placeholder={t("billing.billingEmailPlaceholder")} />
    </Form.Item>
  );
};

export default BillingEmail;
